import { render } from "./LgFive.vue?vue&type=template&id=348a91de&scoped=true"
import script from "./LgFive.vue?vue&type=script&lang=js"
export * from "./LgFive.vue?vue&type=script&lang=js"

import "./LgFive.vue?vue&type=style&index=0&id=348a91de&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348a91de"]])

export default __exports__